import { ReadonlyVec3 } from 'gl-matrix';
import { gl } from '../../../Engine';
import { Uniform } from './Uniform';

export class UniformVec3 extends Uniform {
    constructor(name: string) {
        super(name);
    }

    public loadVec3(vector: ReadonlyVec3): void;

    public loadVec3(vector: Array<number>): void;

    public loadVec3(vector: { x: number; y: number; z: number }): void;

    public loadVec3(x: number, y: number, z: number): void;

    loadVec3(
        vector:
            | Array<number>
            | { x: number; y: number; z: number }
            | ReadonlyVec3
            | number,
        y?: number,
        z?: number
    ) {
        if (this.location) {
            if (vector instanceof Array || vector instanceof Float32Array) {
                gl.uniform3fv(this.location, vector);
            } else if (typeof vector === 'number') {
                gl.uniform3f(this.location, vector, y as number, z as number);
            } else {
                gl.uniform3f(this.location, vector.x, vector.y, vector.z);
            }
        }
    }
}
